module.exports = new __parcel__URL__("incidents-task-one-illustration-dark.acd0e053.png").toString();